
import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import './Liability.css';

const Liability = () => {
  // Set the default expanded state to the first accordion (panel0)
  const [expanded, setExpanded] = useState("panel0");

  // Data for each accordion
  const accordionData = [
    {
      title: "Automatically Adjusted State Coverage Limits",
      content: "RentShield dynamically adjusts coverage limits to meet each state's legal requirements, ensuring seamless compliance and allowing you to operate confidently across all state lines.",
      image: "/img/rentshield/liability_1.webp",
    },
    {
      title: "Third-Party Property Damage and Bodily Injury Liability",
      content: "Protects you against claims arising from damages or injuries to third parties caused by your rental vehicles -- ensuring peace of mind and financial security.",
      image: "/img/rentshield/liability_2.webp",
    },
  ];


  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (

 

            <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewLeft">
                          {accordionData.map((accordion, index) => (
                            expanded === `panel${index}` ? (
                              <Box key={index} sx={{ textAlign: 'center' }}>
                                <img
                                  src={accordion.image}
                                  alt={`logo for ${accordion.title}`}
                                />
                              </Box>
                            ) : null
                          ))}
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewRight">
                  <h3>State Minimum <span>Liability Insurance</span></h3>
                      {accordionData.map((accordion, index) => (
                        <Box key={index} className="boxAccordian">
                          <Accordion className="headingAccordian"
                            expanded={expanded === `panel${index}`}
                            onChange={handleAccordionChange(`panel${index}`)}
                          >
                            <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    >
                              
                              <Typography>
                                {accordion.title}
                              </Typography>
                            </AccordionSummary>
                          </Accordion>
                          {/* Content below the accordion button */}
                          {expanded === `panel${index}` && (
                            <Box className="summaryAccordian">
                              <Typography>{accordion.content}</Typography>
                            </Box>
                          )}
                        </Box>
                      ))}
                  </div>
                </div>

            </div>
 
    
  );
};

export default Liability;
